import React, { useEffect, useState } from 'react';
import { push } from 'connected-react-router';
import { useDispatch, useSelector } from 'react-redux';
import { ROUTE_PATH, ROUTE_NAME } from 'utils/constants/router';
import { REDIRECT_URL_SEARCH_PARAM, AUTH_EMAIL_URL_SEARCH_PARAM } from 'utils/constants/urlSearchParameters';
import useRecaptcha from 'utils/hooks/useRecaptcha';
import { authenticationActions } from 'components/Authentication/actions';
import { useTranslation } from 'utils/modifiedTranslation';
import { useLocationSearchParameters } from 'utils/hooks/useLocationSearchParameters';
import Form, { FORM_INPUT_TYPES, FORM_VALIDATORS } from 'new-ui/Components/Form';
import Button from 'new-ui/Components/Button';

const loginForm = {
  inputs: {
    email: {
      type: FORM_INPUT_TYPES.INPUT,
      icon: 'email',
      placeholder: 'Your email',
    },
    password: {
      type: FORM_INPUT_TYPES.PASSWORD,
      placeholder: 'Your password',
    },
  },
  data: {
    email: '',
    password: '',
  },
};

export const EmailLogin = () => {
  const { [AUTH_EMAIL_URL_SEARCH_PARAM]: emailSearchParam } = useLocationSearchParameters();

  const { t } = useTranslation();
  const { error: serverError } = useSelector((state) => ({
    error: state?.authentication?.error,
  }));
  const [error, setError] = useState(null);

  loginForm.inputs.email.placeholder = t('login.your_email');
  loginForm.inputs.password.placeholder = t('login.your_password');

  useEffect(() => {
    if (emailSearchParam && document.querySelector('.form-part.email input')) {
      document.querySelector('.form-part.email input').value = emailSearchParam;
      loginForm.data.email = emailSearchParam;
    }
  }, [emailSearchParam]);

  const dispatch = useDispatch();
  const { recaptcha, getRecaptchaTokenAsync } = useRecaptcha();

  const login = async () => {
    const email = loginForm?.data?.email;
    const password = loginForm?.data?.password;

    if (!email && !password) {
      setError(t('login.email_and_password_are_missing'));
      return false;
    }
    if (!email) {
      setError(t('login.email_is_missing'));
      return false;
    }
    if (!FORM_VALIDATORS.EMAIL(email)) {
      setError(t('login.invalid_email_address'));
      return false;
    }

    if (!password) {
      setError(t('login.invalid_password'));
      return false;
    }

    setError(null);

    dispatch(
      authenticationActions.requestLogin({
        info: {
          email: email.toLowerCase(),
          password,
        },
        recaptchaToken: await getRecaptchaTokenAsync(),
      }, null, new URLSearchParams(window.location.search).get(REDIRECT_URL_SEARCH_PARAM)),
    );
  };

  return (
    <div className="email-login">
      {recaptcha}
      <div className="login-form">
        <div className="header">
          <h1>
            {t('login.quick_login_with_email_and_password')}
          </h1>
        </div>
        <Form
          form={loginForm}
          onenter={login}
        />
        <div className="action">
          <span
            onClick={() => {
              dispatch(push(ROUTE_PATH[ROUTE_NAME.FORGOT_PASSWORD]));
            }}
          >
            {t('login.forgot_password')}
          </span>
        </div>
        {serverError || error ? (
          <div className="login-error">
            {(serverError && t(serverError)) || error}
          </div>
        ) : null}
        <div className="login-button-holder">
          <Button action={login} title={t('login.enter')} />
        </div>
      </div>
    </div>
  );
};
